import { render, staticRenderFns } from "./StatisticsData.vue?vue&type=template&id=9b6e4cee&scoped=true&"
import script from "./StatisticsData.vue?vue&type=script&lang=js&"
export * from "./StatisticsData.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsData.vue?vue&type=style&index=0&id=9b6e4cee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6e4cee",
  null
  
)

export default component.exports